import { render, staticRenderFns } from "./DocumentImagePreview.vue?vue&type=template&id=1fbdd2b8&scoped=true"
import script from "./DocumentImagePreview.vue?vue&type=script&lang=ts"
export * from "./DocumentImagePreview.vue?vue&type=script&lang=ts"
import style0 from "./DocumentImagePreview.vue?vue&type=style&index=0&id=1fbdd2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbdd2b8",
  null
  
)

export default component.exports